import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/lib/queries/query-keys";

interface TestItem {
  id: number;
  name: string;
  dueDate: string | null;
  createdAt: string;
}

export function useDbTestList() {
  return useQuery({
    queryKey: queryKeys.dbTest.list,
    queryFn: async (): Promise<TestItem[]> => {
      const res = await fetch("/api/db-test");
      if (!res.ok) throw new Error("Failed to load");
      const data = (await res.json()) as { items: TestItem[] };
      return data.items;
    },
  });
}

export function useDbTestCreate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; dueDate?: string | null }): Promise<TestItem> => {
      const res = await fetch("/api/db-test", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      });
      if (!res.ok) throw new Error("Failed to create");
      const data = (await res.json()) as { item: TestItem };
      return data.item;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.dbTest.list });
    },
  });
}

export function useDbTestDelete() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number): Promise<void> => {
      const res = await fetch(`/api/db-test/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed to delete");
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.dbTest.list });
    },
  });
}
